import { render } from "./RingProgress.vue?vue&type=template&id=0b497f0c"
import script from "./RingProgress.vue?vue&type=script&lang=js"
export * from "./RingProgress.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__